<template>
  <ValidationObserver
    ref="observer"
    class="needs-validation form-custom-format"
    :class="{ 'was-validated': validated }"
    tag="form"
    v-slot="{ passes }"
    @submit.prevent="onSubmitForm"
  >
    <el-dialog
      title="Department"
      :visible.sync="syncModal"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="600px"
      class="text-left brand-dialog"
      @closed="dialogState(false)"
    >
      <mdb-container class="mt-0 mb-0">
       
        <ThatsInput
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Name"
          vid="name"
          name="name"
          v-model="form.name"
          :validated="validated"
          :rules="'required'"
          :show_error="true"
          size="sm"
        />
        <ThatsTextarea
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Description"
          vid="description"
          name="description"
          v-model="form.description"
          :validated="validated"
          :rules="''"
          size="sm"
        />
        <ThatsNumber
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Sort Order"
          vid="sort_order"
          name="sort_order"
          v-model="form.sort_order"
          :validated="validated"
          :rules="'required|min_value:0'"
          :show_error="true"
          size="sm"
        />
        <ThatsRadio
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Status"
          vid="status"
          name="status"
          orientation="inline"
          :data="statusOptions"
          v-model="form.status"
          :validated="validated"
          :rules="'required'"
          size="sm"
        />
        
      </mdb-container>

      <template slot="footer">
        <mdb-btn v-if="formStatus === 'update'" color="elegant" size="sm" @click.native="openHistoryDialog">
          History
        </mdb-btn>
        <mdb-btn color="elegant" size="sm" :disabled="formLoading" @click.native="passes(onSubmitForm)">
          <span v-if="formLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ formLoading ? 'Loading...' : 'Save' }}
        </mdb-btn>
        <mdb-btn color="grey" size="sm" @click.native="closeDialog">Close</mdb-btn>
      </template>
    </el-dialog>
    <HistoryDialog ref="historyDialog" />
  </ValidationObserver>
</template>

<script>
import { mdbBtn, mdbContainer } from 'mdbvue';
import { ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  ThatsInput,
  ThatsNumber,
  ThatsRadio,
  ThatsTextarea
} from '../../components/thats/Thats';
import HistoryDialog from '../../components/thats/HistoryDialog.vue';

export default {
  components: {
    ValidationObserver,
    ThatsInput,
    ThatsNumber,
    ThatsRadio,
    ThatsTextarea,
    mdbBtn,
    mdbContainer,
    HistoryDialog
  },

  data() {
    return {
      validated: false,
      form: this.formVar(),
      formLoading: false,
      response: {
        error: null,
        message: null
      },
      statusOptions: [
        { label: 'Active', value: 'true' },
        { label: 'Inactive', value: 'false' }
      ],
      syncModal: false
    };
  },

  methods: {
    ...mapActions('ProductDepartmentModule', ['storeRecord', 'updateRecord']),
    ...mapMutations('ProductDepartmentModule', ['setFormStatusCreate']),
    ...mapMutations('HistoryModule', ['setModule', 'setRecordId']),

    formVar() {
      return {
        name: null,
        description: null,
        sort_order: 0,
        attr: { },
        status: 'true',
        hidden: false
      };
    },

    openDialog() {
      this.syncModal = true;
    },

    openHistoryDialog() {
      if (!this.form || !this.form.id) {
        return;
      }

      this.setModule('product-department');
      this.setRecordId(this.form.id);
      this.$refs.historyDialog.openDialog();
    },

    closeDialog() {
      this.syncModal = false;
    },

    onSubmitForm() {
      if (this.formLoading) {
        return;
      }

      this.validated = true;
      this.formLoading = true;

      const request = this.formStatus === 'create'
        ? this.storeRecord(this.form)
        : this.updateRecord(this.form);

      request.then((response) => {
        this.$ThatsNotify.success({
          message: this.formStatus === 'create' ? undefined : 'Record was successfully updated'
        });
        this.$emit('success', response);
        this.closeDialog();
        this.FormResetter();
      }).catch((error) => {
        this.formLoading = false;
        this.response.error = 1;

        const responseData = error.response && error.response.data
          ? error.response.data
          : null;

        if (responseData && responseData.errors) {
          const fieldErrors = Object.keys(responseData.errors).reduce((errors, field) => {
            const messages = responseData.errors[field];
            errors[field] = Array.isArray(messages) ? messages : [messages];
            return errors;
          }, {});

          this.$refs.observer.setErrors(fieldErrors);
        } else if (responseData && responseData.message) {
          this.$refs.observer.setErrors({
            name: [responseData.message]
          });
        } else if (error.request) {
          this.response.message = error.request;
        } else {
          this.response.message = error.message;
        }
      });
    },

    FormResetter() {
      this.form = this.formVar();
      this.validated = false;
      this.formLoading = false;
      this.setFormStatusCreate();

      this.$nextTick(() => {
        if (this.$refs.observer) {
          this.$refs.observer.reset();
        }
      });
    },

    normalizeStatus() {
      this.form.status = [true, 1, '1', 'true'].includes(this.form.status)
        ? 'true'
        : 'false';
    },

    dialogState(state) {
      if (!state) {
        this.FormResetter();
      }
    },

    emitDelete() {
      this.$emit('delete', this.formRecord);
    }
  },

  computed: {
    ...mapGetters('ProductDepartmentModule', ['formStatus', 'formRecord'])
  },

  watch: {
    formRecord(value) {
      if (this.formStatus === 'update' && value) {
        this.form = JSON.parse(JSON.stringify(value.row || value));

        if (!this.form.attr) {
          this.form.attr = this.formVar().attr;
        }

        this.normalizeStatus();
      }
    },
   
  }
};
</script>
